import { Route, Routes } from "react-router";
import { NotFound } from "../../app/pages/NotFound";
import { WILDCARD_ROUTE } from "../../common/constants";
import { TopAgentType } from "../../common/enums";
import { Permission } from "../../common/security/enums";
import PageWithPermission from "../auth/components/PageWithPermission";
import { ChinaCompetitionContainer } from "./containers/ChinaCompetitionContainer";
import { SloveniaCompetitionContainer } from "./containers/SloveniaCompetitionContainer";
import { COMPETITION_ROUTE_PATHS } from "./path";

export const CompetitionRoutes = () => {
  return (
    <Routes>
      <Route
        path={COMPETITION_ROUTE_PATHS.china.path}
        element={
          <PageWithPermission
            component={<ChinaCompetitionContainer />}
            permissions={[Permission.AGENT_READ]}
            allowedTopAgents={[TopAgentType.PLUS]}
          />
        }
      />

      <Route
        path={COMPETITION_ROUTE_PATHS.slovenia.path}
        element={
          <PageWithPermission
            component={<SloveniaCompetitionContainer />}
            permissions={[Permission.AGENT_READ]}
            allowedTopAgents={[TopAgentType.PLUS]}
          />
        }
      />

      <Route path={WILDCARD_ROUTE} element={<NotFound />} />
    </Routes>
  );
};
